(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Plans",
                    {
                        url: "/Plans",
                        component: "marketingTrackerPlansNew",
                        PageTitle: "Plans | Marketing Tracker",
                        resolve: {
                            marketingTrackerAgent: ["marketingTrackerAgentApi", function (marketingTrackerAgentApi) {
                                return marketingTrackerAgentApi.get();
                            }],
                            marketingPlans: ["marketingPlanApi", "marketingTrackerAgent", function (marketingPlanApi, marketingTrackerAgent) {
                                return marketingPlanApi.getMarketingPlanSummaries(marketingTrackerAgent.AgentId);
                            }],
                            seminarPlans: ["marketingPlanApi", "marketingTrackerAgent", function (marketingPlanApi, marketingTrackerAgent) {
                                return marketingPlanApi.getSeminarPlanSummaries(marketingTrackerAgent.AgentId);
                            }],
                            collegePlans: ["marketingPlanApi", "marketingTrackerAgent", function (marketingPlanApi, marketingTrackerAgent) {
                                return marketingPlanApi.getCollegePlanSummaries(marketingTrackerAgent.AgentId);
                            }]
                        }
                    });
        }
    ]);

    app
        .component("marketingTrackerPlansNew",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Plans/plans-new-template.html",
                controller: marketingTrackerPlansNewController,
                bindings: {
                    marketingTrackerAgent: "<",
                    marketingPlans: "<",
                    seminarPlans: "<",
                    collegePlans: "<"
                }
            });

    marketingTrackerPlansNewController.$inject = ["_", "$state", "amplitudeService"];
    function marketingTrackerPlansNewController(_, $state, amplitudeService) {
        var $ctrl = this;

        var year = (new Date()).getUTCFullYear();
        var years = [];

        for (var i = year - 2; i <= year + 2; i++)
            years.push(i);

        ng.extend($ctrl,
            {
                reset: reset,
                getRecentMarketingPlanId: getRecentMarketingPlanId,
                getRecentSeminarPlanId: getRecentSeminarPlanId,
                getRecentCollegePlanId: getRecentCollegePlanId,
                ui: {
                    year: year,
                    years: years
                }
            });

        function reset() {
            $state.go("Home.Tools.MarketingTrackerNew.Plans");
        }

        function getRecentMarketingPlanId() {
            var plan = _.filter($ctrl.marketingPlans,
                function (row) {
                    return (new Date(row.PlanDate)).getUTCFullYear() === $ctrl.ui.year;
                });
            if(!plan || !plan.length)
                return null;
            var latestPlan = _.maxBy(plan,
                function (row) {
                    return row.CreatedOnDate;
                });
            return latestPlan ? latestPlan.Id : null;
        }

        function getRecentSeminarPlanId() {
            var plan = _.filter($ctrl.seminarPlans,
                function (row) {
                    return (new Date(row.PlanDate)).getUTCFullYear() === $ctrl.ui.year;
                });
            if(!plan || !plan.length)
                return null;
            var latestPlan = _.maxBy(plan,
                function (row) {
                    return row.CreatedOnDate;
                });
            return latestPlan ? latestPlan.Id : null;
        }

        function getRecentCollegePlanId() {
            var plan = _.filter($ctrl.collegePlans,
                function (row) {
                    return (new Date(row.PlanDate)).getUTCFullYear() === $ctrl.ui.year;
                });
            if(!plan || !plan.length)
                return null;
            var latestPlan = _.maxBy(plan,
                function (row) {
                    return row.CreatedOnDate;
                });
            return latestPlan ? latestPlan.Id : null;
        }
    }

})(window.app, window.angular); //jshint ignore:line